<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>{{ title }}</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickEnableAll()">
                    <i class="fa fa-fighter-jet"></i> Habilitar Todos</button>
            </div>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de {{ title }}</h3>
            </div>
            <div class="card-body">
                <data-table :resource="resource">
                    <tr slot="heading">
                        <th>#</th>
                        <th>ID</th>
                        <th>Cód. Interno</th>
                        <th>Unidad</th>
                        <th>Descripcion</th>
                        <th>Fecha de Inhabilitación</th>
                        <th class="text-right">Acciones</th>
                    </tr>
                    <tr slot-scope="{ index, row }">
                        <td>{{ index }}</td>
                        <td>{{ row.id }}</td>
                        <td>{{ row.internal_id }}</td>
                        <td>{{ row.unit_type_id }}</td>
                        <td>{{ row.description }}</td>
                        <td>{{ row.created_at }}</td>
                        <td class="text-right">
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-success"
                                @click.prevent="clickEnable(row.id)">Habilitar</button>
                        </td>
                    </tr>
                </data-table>
            </div>
            <!-- 
            <category-form :showDialog.sync="showDialog" :recordId="recordId"></category-form> -->
        </div>
    </div>
</template>

<script>

import DataTable from '../../../../../../../resources/js/components/DataTable.vue'
import { deletable } from '../../../../../../../resources/js/mixins/deletable'

export default {
    mixins: [deletable],
    components: { DataTable },
    data() {
        return {
            title: null,
            showDialog: false,
            resource: 'disabled',
            recordId: null,
        }
    },
    created() {
        this.title = 'Productos Inhabilitados';
    },
    methods: {
        clickEnable(id) {
            this.enable(`/${this.resource}/enable/${id}`).then(() =>
                this.$eventHub.$emit("reloadData")
            );
        },
        clickEnableAll() {
            this.enable(`/${this.resource}/enableall`).then(() =>
                this.$eventHub.$emit("reloadData")
            );
        }
    }
}
</script>


// WEBPACK FOOTER //
// modules/Item/Resources/assets/js/views/disabled/index.vue